import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as GoogleIcon } from '../../../../assets/images/Google.svg';
import { ReactComponent as MicrosoftIcon } from '../../../../assets/images/microsoft.svg';
import Button from '../../../../components/shared/Button/Button';
import Modal from '../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../helpers/IsMobile';
import baseServerUrl from '../../../../services/apiServer';

import styles from './SyncSourceModal.module.scss';

const handleMicrosoftContactsSync = () => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${baseServerUrl}/auth/microsoft_graph_auth?new_user_app=${true}&prompt=consent`;
  document.body.appendChild(form);
  form.submit();
};

const handleGoogleContactsSync = () => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${baseServerUrl}/auth/google_oauth2?new_user_app=${true}&prompt=consent`;
  document.body.appendChild(form);
  form.submit();
};

const SyncSourceModal = ({ showModal, handleToggleModal }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();

  return (
    <Modal
      show={showModal}
      onHide={handleToggleModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('syncSources.addSyncSource')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.contentCont}>
          <p className={styles.text}>{t('syncSources.selectPlatform')}</p>
          <div className={styles.btnsCont}>
            <div className={styles.btnCont} onClick={handleGoogleContactsSync} role="presentation">
              <div className={styles.iconCont}>
                <GoogleIcon />
              </div>
              <div>
                <p className={styles.name}>{t('network.google')}</p>
                <p className={styles.description}>{t('syncSources.syncYourContacts')}</p>
              </div>
            </div>
            <div className={styles.btnCont} onClick={handleMicrosoftContactsSync} role="presentation">
              <div className={styles.iconCont}>
                <MicrosoftIcon />
              </div>
              <div>
                <p className={styles.name}>{t('syncSources.microsoft')}</p>
                <p className={styles.description}>{t('syncSources.addYourContactsBtn')}</p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <Button className={styles.cancelBtn} onClick={handleToggleModal}>
          {t('cancel')}
        </Button>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default SyncSourceModal;
